import { arrayBufferDownload, arrayBufferDownloadExcel, downloadCSV } from "../../../../utils/download";
import { decorateEmptyGridValues, setColumnDefaultExtraProps } from "../../../../utils/table/gridUtils";
import { UPLOAD_IMAGE } from "../../../types/uploadimage.type";
import {
  FETCH_VEHICLE_ACTYPE_LIST, 
  TOAST, 
  FETCH_VEHICLE_ACTYPE_INIT,
  FETCH_VEHICLE_ACTYPE_DETAIL,
  EXPORT_VEHICLE_ACTYPE,
  CREATE_VEHICLE_ACTYPE,
  EDIT_VEHICLE_ACTYPE,
  INIT_CREATE_VEHICLE_ACTYPE_SCREEN,
  VEHICLE_MODELDD,
  VEHICLE_ACTYPE_DD,
  DELETE_VEHICLE_ACTYPE,
  SET_DELETE_CONFIRMATION_POPUP_VISIBILITY,
  VEHICLE_ACTYPE_SAVE_TABLE_STATE
} from "../../../types/vehicleactype.type";



  const formFieldValueMap = {
    id:null,
    description:"",
    modBy:"",
    modTime:"",
    status:1,
    title:"",
    userId:""
  };
  
  const INITIAL_STATE = {
    vehicleAcTypeListview: [],
    vehicleModelDD:[],
    vehicleAcTypeDD: [],
    isVehicleModelDDSuccess: false,
    isVehicleModelDDError: false,
    isVehicleAcTypeDDSuccess: false,
    isVehicleAcTypeDDError: false,
    isLoading: false,
    error: null,
    formFieldValueMap,
    isVehicleAcTypeCreateSuccess: false,
    isVehicleAcTypeCreateError: false,
    isVehicleAcTypeDetailSuccess: false,
    isVehicleAcTypeDetailError: false,
    isVehicleAcTypeEditSuccess: false,
    isVehicleAcTypeEditError: false,
    isVehicleAcTypeExportSuccess: false,
    isVehicleAcTypeExportError: false,
    isUploadImageSuccess: false,
    isUploadImageError: false,
    imageUploadResponse:null,
    savedTableState: null
  };
  
  const tranformToGridView = (data) => {
    const rows = data.map((item) => {
      const {
        crtBy,
crtTime,
description,
id,
modBy,
modTime,
status,
title
      } = item;
  
      const transformedValues = {
        crtBy,
crtTime,
description,
id,
modBy,
modTime,
status,
title
      };
      const decoratedValues = {};
      Object.keys(transformedValues).forEach((key) => {
        decoratedValues[key] = decorateEmptyGridValues(transformedValues[key]);
      });
      return decoratedValues;
    });
  
    const columns = [
      {
        colLabel: "ID",
        dataKey: "id",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: false,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Ac Type",
        dataKey: "title",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Description",
        dataKey: "description",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },

      {
        colLabel: "Crt By",
        dataKey: "crtBy",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Crt Time",
        dataKey: "crtTime",
        extraProps: {
          isSortable: true,
          isDateField: true,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Mod By",
        dataKey: "modBy",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Edit Time",
        dataKey: "modTime",
        extraProps: {
          isSortable: true,
          isDateField: true,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      },
      {
        colLabel: "Status",
        dataKey: "status",
        extraProps: {
          isSortable: true,
          isDateField: false,
          shouldFilter: true,
          hidden: false,
          showFilterMenu: false,
          filterPlaceholder: "Search..."
        }
      }
    ];
  
    return {
      datas: { columns, rows },
    };
  };

  export const vehicleAcTypeReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
      case FETCH_VEHICLE_ACTYPE_INIT:
        return { ...INITIAL_STATE, isLoadingPage: true, savedTableState: state.savedTableState };
      case FETCH_VEHICLE_ACTYPE_DETAIL.START:
        return { ...state, isLoading: true, isVehicleAcTypeDetailSuccess: false };
      case EXPORT_VEHICLE_ACTYPE.START:
        case UPLOAD_IMAGE.START:
      case FETCH_VEHICLE_ACTYPE_LIST.START:
      case CREATE_VEHICLE_ACTYPE.START:
        case EDIT_VEHICLE_ACTYPE.START:
          case VEHICLE_MODELDD.START:
          case VEHICLE_ACTYPE_DD.START:
          case DELETE_VEHICLE_ACTYPE.START:
        return { ...state, isLoading: true };
  
      case FETCH_VEHICLE_ACTYPE_LIST.SUCCESS: {
        const { page, data } = action.payload;
       
        let resetState = {
          vehicleAcTypeListview: [],
          paginationInfo:null,
          error: null,
          isLoading: false,
          isLoadingPage: false,
          isPageLevelError: false,
          isVehicleAcTypeCreateSuccess: false,
          isVehicleAcTypeCreateError: false,
          savedTableState: state.savedTableState,
        };
        if (!data) {
          return resetState;
        }
        const { number, size, totalElements, totalPages } = page;
        const { datas } = tranformToGridView(data);
        return {
          ...resetState,
          vehicleAcTypeListview: datas,
          paginationInfo: {
            pageSize: size,
            totalRecords: totalElements,
            totalPages: totalPages,
            pageNumber: number,
          },
        };
      }
      case FETCH_VEHICLE_ACTYPE_LIST.ERROR: {
        const { error } = action.payload;
  
        return {
          ...state,
          vehicleAcTypeListview: [],
          isLoading: false,
          isLoadingPage: false,
          error,
          isPageLevelError: true,
          isvehicleAcTypeDeletionSuccess: false,
          isvehicleAcTypeDeletionError: false,
          shouldOpenDeleteConfirmationPopup: false,
        };
      }

    case FETCH_VEHICLE_ACTYPE_DETAIL.SUCCESS: {
      const temp = action.payload;
      if (action.payload && typeof action.payload === "object") {
        Object.keys(action.payload).forEach((key) => {
          if (formFieldValueMap.hasOwnProperty(key)) {
              temp[key] = action.payload[key];
          }
        });
      }

      return {
        ...state,
        isLoading: false,
        formFieldValueMap: temp,
        isVehicleAcTypeDetailSuccess: true,
      };
    }
    case FETCH_VEHICLE_ACTYPE_DETAIL.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isVehicleAcTypeDetailSuccess: false,
        isVehicleAcTypeDetailError: true,
      };
    }

    //DD
    case VEHICLE_MODELDD.SUCCESS: {
      const temp = action.payload;
 
      return {
        ...state,
        isLoading: false,
        vehicleModelDD:temp,
        isVehicleModelDDSuccess: true,
        isVehicleModelDDError: false,
      };
    }
    case VEHICLE_MODELDD.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isVehicleModelDDSuccess: false,
    isVehicleModelDDError: true,
      };
    }
    //END DD
   
    // AC Type DD
    
    case VEHICLE_ACTYPE_DD.SUCCESS: {
      const temp = action.payload;
 
      return {
        ...state,
        isLoading: false,
        vehicleAcTypeDD: temp,
        isVehicleAcTypeDDSuccess: true,
        isVehicleAcTypeDDError: false,
      };
    }
    case VEHICLE_ACTYPE_DD.ERROR: {
      const { error } = action.payload;

      return {
        ...state,
        error,
        isVehicleAcTypeDDSuccess: false,
        isVehicleAcTypeDDError: true,
      };
    }
    // END AC Type DD


// UPLOAD_IMAGE Start
case UPLOAD_IMAGE.ERROR: {
  const { error } = action.payload;

  return {
    ...state,
    isLoading: false,
    isLoadingPage: false,
    error,
    isUploadImageSuccess: false,
    isUploadImageError: true,
    shouldOpenExportConfirmationPopup: false,
  };
}

case UPLOAD_IMAGE.SUCCESS: {
  const  {data}  = action.payload;
   return {
    ...state,
    imageUploadResponse:data,
    isUploadImageSuccess: true,
    isUploadImageError: false,
    shouldOpenExportConfirmationPopup: false,
  };
}

// UPLOAD_IMAGE End

// Export Start
case EXPORT_VEHICLE_ACTYPE.ERROR: {
  const { error } = action.payload;

  return {
    ...state,
    isLoading: false,
    isLoadingPage: false,
    error,
    isVehicleAcTypeExportSuccess: false,
    isVehicleAcTypeExportError: true,
    shouldOpenExportConfirmationPopup: false,
  };
}

case EXPORT_VEHICLE_ACTYPE.SUCCESS: {
  const  data  = action.payload;
  arrayBufferDownloadExcel(data,"vehicle-actype.xls");
   return {
    ...state,
    isVehicleAcTypeExportSuccess: true,
    isVehicleAcTypeExportError: false,
    shouldOpenExportConfirmationPopup: false,
  };
}

// Export End

// EDIT
case EDIT_VEHICLE_ACTYPE.ERROR: {
  const { error } = action.payload;
  return {
    ...state,
    error,
    isLoading: false,
    isVehicleAcTypeEditSuccess: false,
    isVehicleAcTypeEditError: true,
  };
}

case EDIT_VEHICLE_ACTYPE.SUCCESS: {
  return {
    ...state,
    isLoading: false,
    isVehicleAcTypeEditSuccess: true,
    isVehicleAcTypeEditError: false,
  };
}

// EDIT END

// Create
case INIT_CREATE_VEHICLE_ACTYPE_SCREEN: {
  return { ...INITIAL_STATE, savedTableState: state.savedTableState };
}

case CREATE_VEHICLE_ACTYPE.ERROR: {
  const { error } = action.payload;
  return {
    ...state,
    error,
    isLoading: false,
    isVehicleAcTypeCreateSuccess: false,
    isVehicleAcTypeCreateError: true,
  };
}
case CREATE_VEHICLE_ACTYPE.SUCCESS: {
  return {
    ...state,
    isLoading: false,
    isVehicleAcTypeCreateSuccess: true,
    isVehicleAcTypeCreateError: false,
  };
}

//End
  

    case DELETE_VEHICLE_ACTYPE.SUCCESS:
      return {
        ...state,
        isLoading: false,
        isVehicleAcTypeDeleteSuccess: true,
        isVehicleAcTypeDeleteError: false,
        shouldOpenDeleteConfirmationPopup: false,
      };
    case DELETE_VEHICLE_ACTYPE.ERROR: {
      const { error } = action.payload;
      return {
        ...state,
        error,
        isLoading: false,
        isVehicleAcTypeDeleteSuccess: false,
        isVehicleAcTypeDeleteError: true,
        shouldOpenDeleteConfirmationPopup: false,
      };
    }
    case SET_DELETE_CONFIRMATION_POPUP_VISIBILITY:
      return {
        ...state,
        shouldOpenDeleteConfirmationPopup: action.payload,
        isVehicleAcTypeDeleteSuccess: false,
        isVehicleAcTypeDeleteError: false,
      };

    case VEHICLE_ACTYPE_SAVE_TABLE_STATE: {
      return {
        ...state,
        savedTableState: action.payload,
      };
    }

      case TOAST.RESET: {
        return {
          ...state,
          isVehicleAcTypeCreateSuccess: false,
          isVehicleAcTypeCreateError: false,
          isVehicleAcTypeEditError: false,
          isVehicleAcTypeEditSuccess: false,
          isVehicleAcTypeDetailError: false
        };
      }
      default:
        return state;
    }
  };
  